import React, { useEffect, useMemo, useState } from "react";
import OrphanMSearchResult from 'components/LM/SocialMediaProfile/Orphan/OrphanMSearchResult';
import K2Api from 'lib/ajax/K2Api';

const BATCH_SIZE = 100;

async function fetchAndEnrichBatch(k2Api, batchUrls) {
	const response = await k2Api.post('socialmedia/msearch', { urls: batchUrls });

	return Promise.all(response.data.map(async (profile) => {
		if (!profile.content) {
			return { ...profile, content: { result: [] } };
		}
		const resultData = await Promise.all(profile.content.result.map(async (item) => {
			const crawlingResponse = await k2Api.get(`/socialmedia/${profile.content.type}/crawling/${item.id}`);
			return { ...item, crawling: crawlingResponse.data };
		}));
		return { ...profile, content: { ...profile.content, result: resultData } };
	}));
}

function OrphanMSearchResults({ location }) {
	const allUrls = useMemo(() => location.state.urls ?? [], [location.state.urls]);
	const [currentPage, setCurrentPage] = useState(1);
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(true);

	const totalPages = Math.ceil(allUrls.length / BATCH_SIZE) || 1;

	useEffect(() => {
		let cancelled = false;
		const fetchBatch = async () => {
			setLoading(true);
			const start = (currentPage - 1) * BATCH_SIZE;
			const batchUrls = allUrls.slice(start, start + BATCH_SIZE);
			const k2Api = new K2Api();
			try {
				const enriched = await fetchAndEnrichBatch(k2Api, batchUrls);
				if (!cancelled) setResults(enriched);
			} catch {
				if (!cancelled) setResults([]);
			}
			if (!cancelled) setLoading(false);
		};

		if (allUrls.length > 0) {
			fetchBatch();
		} else {
			setLoading(false);
		}

		return () => { cancelled = true; };
	}, [currentPage, allUrls]);

	const handlePageChange = (page) => {
		setCurrentPage(page);
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	return (
		<OrphanMSearchResult
			results={results}
			loading={loading}
			currentPage={currentPage}
			totalPages={totalPages}
			totalUrls={allUrls.length}
			onPageChange={handlePageChange}
			allUrls={allUrls}
			batchSize={BATCH_SIZE}
		/>
	);
}

export default OrphanMSearchResults;
